














































import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component
export default class ProgrammeList extends Vue {
  @Prop([]) public tabList: any;
  @Model('change', { type: Number }) private articleTypeId!: string;
  // @Prop({}) public articleTypeId: any;
  private page: any = 1;
  private pageSize: any = 10;
  private total: any = 0;
  private totalPage: any = 0;
  private keyword: any = this.$route.query.name || '';
  private loading: any = false;
  private isNoData: any = null;
  private articleData: any = [];
  private handleDetail(item: any) {
    this.$emit('to-detail', item);
  }
  private created() {
    const page: any = this.$route.query.page;
    this.page = page || 1;
    this.getArticleList();
  }
  private handleCurrentChange(val: string) {
    // this.page = val;
    // this.getArticleList();
    this.$router.push({
      path: '/programme/index.html',
      query: {
        pType: this.tabList.filter((ele: any) => ele.id === this.articleTypeId)[0].eng,
        name: this.keyword || undefined,
        page: val,
      },
    });
  }
  /**
   * 文章列表数据
   */
  private async getArticleList() {
    let list: any = null;
    list = await this.$apis.getArticleList({
      articleTypeId: this.articleTypeId,
      page: this.page,
      pageSize: this.pageSize,
      systemType: 2,
      keyword: this.keyword,
    });
    if (list && list !== null) {
      console.log(list, 'list');
      // this.articleData = this.articleData.concat(list.data);
      if (list.data.length === 0) {
        this.isNoData = 1;
      } else {
        this.isNoData = 0;
      }
      this.articleData = list.data;
      this.total = list.total;
      this.totalPage = list.totalPage;
    }
  }
  /**
   * 判断页码数是否加载
   */
  // private noMore() {
  //   return this.page >= this.totalPage;
  // }
  /**
   * 判断是否加载
   */
  // private disabledShow() {
  //   return this.loading || this.noMore();
  // }
  /**
   * 加载更多
   */
  private loadData() {
    this.loading = true;

    setTimeout(() => {
      this.page += 1;
      this.getArticleList();
      this.loading = false;
    }, 2000);
  }
}
